const header4i = function () {
	let userLinksWrapper = document.getElementById("userLinks");

	let init = function () {
		loadUserLinks();
		HeaderView.Init();

		window.addEventListener('appinstalled', function () {
			//do the logging
		});
	},

		HeaderView = (function () {
			let topMenuBar, menuBtn, headerLogo, stickyHead, mainHeader, mainContent,

				init = () => {
					stickyHead = document.querySelector(".topHeader"); //TODO change this class
					headerLogo = (document.querySelector(".outletLogo")) ? document.querySelector(".outletLogo").parentNode : "";
					mainHeader = document.querySelector("header");
					mainContent = document.getElementById("mainContent");

					document.querySelector(".skip").removeAttribute("style");
					mobileChanges();
					window.addEventListener("resize", mobileChanges);
					if (window.innerHeight > 500) window.addEventListener("scroll", makeSticky); // changed this to 500 to account for height of header plus cart dropdown
					makeSticky(); // if page is loaded already scrolled down a bit
				},
				mobileChanges = () => {
					if (window.innerWidth < 600 && !headerLogo.classList.contains("flexAlignItemsCenter")) {
						headerLogo.classList.add("flexAlignItemsCenter");
					} else if (window.innerWidth >= 600 && headerLogo.classList.contains("flexAlignItemsCenter")) {
						headerLogo.classList.remove("flexAlignItemsCenter");
					}
					if (headerLogo.classList.contains("invisible")) headerLogo.classList.remove("invisible");
				},
				makeSticky = () => {
					if (stickyHead.classList.contains("main-nav-scrolled")) {
						stickyHead.classList.remove("main-nav-scrolled");
					}
				};
			return {
				Init: init
			};
		})(),

		AdobeLog = (function () {
			let pwaInstall = () => {
				if (s) {
					s.event30 = 'PWA Install';
					s.t();
				}
			};
			return {
				PwaInstall: pwaInstall
			};
		})(),

		fadeOut = (element) => {
			element.classList.remove("animateFadeIn");
			element.classList.add("animateFadeOut");
			setTimeout(() => {
				element.classList.add("hide");
			}, 400);
		},
		fadeIn = (element) => {
			element.classList.remove("animateFadeOut");
			element.classList.add("animateFadeIn");
			element.classList.remove("hide");
		},

		HeaderAccount = (function () {
			let accountView, accountLink, accountSVGs,

				init = () => {
					accountView = document.getElementById("accountDropDown");
					accountLink = document.getElementById("accountLink");
					if (accountLink) {
						accountSVGs = accountLink.querySelectorAll("svg");
					}
					if (accountView) {
						accountLink.removeEventListener("click", showHide);
						accountLink.addEventListener("click", showHide);
						accountKeys();
					}
				},
				show = () => {
					fadeIn(accountView);
					accountLink.setAttribute("aria-expanded", "true");
					if (accountSVGs[1]) accountSVGs[1].classList.remove("rotate180");

					document.addEventListener("keydown", escapeAccount);
					document.addEventListener("click", closeClickOutside);
				},
				hide = () => {
					fadeOut(accountView);
					accountLink.setAttribute("aria-expanded", "false");
					if (accountSVGs[1]) accountSVGs[1].classList.add("rotate180");

					document.removeEventListener("keydown", escapeAccount);
					document.removeEventListener("click", closeClickOutside);
				},
				showHide = (e) => {
					e.preventDefault();
					if (accountView.classList.contains("hide")) show();
					else hide();
				},
				closeClickOutside = (e) => {
					let accountWrapper = document.getElementById('hdrActWrapper');
					if (accountWrapper && !accountWrapper.contains(e.target)) hide();
				},
				escapeAccount = (e) => {
					if (e.keyCode === 27) { // allow user to close on escape
						hide();
						accountLink.focus();
					}
				},
				accountKeys = () => {
					if (accountView.querySelector("a") !== null) {
						let accountDropLinks = [].slice.call(accountView.querySelectorAll("a")),
							lastLink = accountDropLinks[accountDropLinks.length - 1];
						lastLink.addEventListener("keydown", function (e) {
							if (e.keyCode == 9 && lastLink == document.activeElement) hide();
						});
					}
				};
			return {
				Init: init
			};
		})(),

		HeaderCart = (function () {
			let cartView, cartSummary, checkoutLink,

				init = () => {
					cartView = document.getElementsByClassName("hdrCartMenu")[0];
					cartSummary = document.getElementById("hdrCartBtn");
					checkoutLink = document.getElementById("checkoutLink");

					if (cartView) { // not an empty cart
						cartSummary.removeEventListener("click", showHide);
						cartSummary.addEventListener("click", showHide);
						cartKeys();
					}
				},
				show = () => {
					fadeIn(cartView);
					cartSummary.setAttribute("aria-expanded", "true");
					document.addEventListener("keydown", escapeCart);
					document.addEventListener("click", closeClickOutside);
				},
				hide = () => {
					fadeOut(cartView);
					cartSummary.setAttribute("aria-expanded", "false");

					document.removeEventListener("keydown", escapeCart);
					document.removeEventListener("click", closeClickOutside);
				},
				showHide = (e) => {
					e.preventDefault();
					if (cartView.classList.contains("hide")) show();
					else hide();
				},
				closeClickOutside = (e) => {
					let cartWrapperElement = document.getElementById('hdrCartWrapper');
					if (cartWrapperElement && !cartWrapperElement.contains(e.target)) hide();
				},
				escapeCart = (e) => {
					if (e.keyCode === 27) { // allow user to close on escape
						hide();
						cartSummary.focus();
					}
				},
				cartKeys = () => {
					checkoutLink.addEventListener("keydown", function (e) {
						if (e.keyCode == 9 && checkoutLink == document.activeElement) hide();
					});
				};
			return {
				Init: init
			};
		})(),

		loadUserLinks = () => {
			if (userLinksWrapper == null) { return; }
			fetch('/Header/UserSpecificLinks', {
				headers: { 'X-Requested-With': 'fetch' }
			}).then(function (response) {
				return (response.ok) ? response.text() : ''; // response.text() returns a promise
			}).then(function (html) {
				if (html.length < 1) { userLinksWrapper.innerHTML = ""; return; }
				userLinksWrapper.innerHTML = html;
				HeaderAccount.Init();
				HeaderCart.Init();
			}).catch(function (e) {
				userLinksWrapper.innerHTML = ""; // remove loading icon
			});
		};

	return {
		Init: init,
		HeaderCart: HeaderCart
	};
};
(function () {
	const loadHeader = new header4i();
	loadHeader.Init();
})();